// Calendar rows use decimal hours (10.5 = 10:30, 10.25 = 10:15). Convert to the
// "HH:mm" format the booking form's time slots use; `${hour}:00` gave "10.5:00".
export const formatHourAsTime = (hour: number): string => {
  const totalMinutes = Math.round(hour * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
